import Vue from "vue";
import { Component } from "vue-property-decorator";
import { departmentRepository } from "@/repositories";
import { IDepartment } from "@/models";
import { FileNames } from "@/enums";

@Component({
    name: "department",
    metaInfo: {
        title: "Department",
    },
})

export default class Department extends Vue {

    public loading: boolean = false;
    public loadingButton: boolean = false;

    public headers = [
        { text: "Name", value: "name", class: "nowrap", cellClass: "fixedHeight", sortable: true },
    ];

    public search = "";

    public fields: IDepartment[] = [];

    get itemsPerPage(): number{
        return this.$store.getters["app/itemsPerPage"];
    }

    async mounted(): Promise<void> {
        this.loading = true;
        departmentRepository.getAllWithRequestsNumber().then(res=> {
            this.fields = res;
            this.loading = false;
        }).catch (error => {
            this.loading = false;
            this.$emit("error", error);
        });
    }

    public handleItemsPerPage(itemsPerPage: number): void{
        this.$store.dispatch("app/updateItemsPerPage", itemsPerPage);
    }

    public async exportData(): Promise<void> {
        this.loadingButton = true;
        departmentRepository.export("export").then(res=> {
            const url = window.URL.createObjectURL(new Blob([res.data]))
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', FileNames.Departement)
            document.body.appendChild(link);
            link.click();
            this.loadingButton = false;
        }).catch (error => {
            this.$emit("error", error);
        });
    }
}
